// Cookie security middleware for LTF Life Changer app
// This script provides utility functions for secure cookie management

/**
 * Sets a secure cookie with appropriate flags
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {object} options - Additional cookie options
 */
export function setSecureCookie(name, value, options = {}) {
  const defaultOptions = {
    path: '/',
    sameSite: 'Lax', // Use Lax to ensure cookies work with most browsing contexts
    secure: window.location.protocol === 'https:', // Only set Secure flag on HTTPS
    expires: 0, // Session cookie by default
    ...options
  };

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  
  // Add options to cookie string
  if (defaultOptions.path) {
    cookieString += `; Path=${defaultOptions.path}`;
  }
  
  if (defaultOptions.sameSite) {
    cookieString += `; SameSite=${defaultOptions.sameSite}`;
  }
  
  if (defaultOptions.secure) {
    cookieString += '; Secure';
  }
  
  if (defaultOptions.expires > 0) {
    const date = new Date();
    date.setTime(date.getTime() + (defaultOptions.expires * 24 * 60 * 60 * 1000));
    cookieString += `; Expires=${date.toUTCString()}`;
  }
  
  // Set the cookie
  document.cookie = cookieString;
  return cookieString;
}

/**
 * Gets a cookie by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
export function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const [cookieName, cookieValue] = cookie.split('=');
    
    if (decodeURIComponent(cookieName) === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

/**
 * Secures all existing cookies by overwriting them with secure versions
 */
export function secureAllCookies() {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const eqPos = cookie.indexOf('=');
    if (eqPos > -1) {
      const name = decodeURIComponent(cookie.substring(0, eqPos));
      const value = decodeURIComponent(cookie.substring(eqPos + 1));
      if (name && value) {
        // Skip already secure cookies
        if (cookie.includes('SameSite=') && cookie.includes('Secure')) continue;
        
        // Replace the cookie with a secure version
        setSecureCookie(name, value);
      }
    }
  }
}

// Export the API
export default {
  setSecureCookie,
  getCookie,
  secureAllCookies
};
